import actionTypes from "../actionTypes";

export function requestBalanceTransfer( { amount, memberIds, transferType } ) {
  return {
    type: actionTypes.BALANCE_TRANSFER_REQUEST,
    amount,
    memberIds,
    transferType
  };
}

export function successBalanceTransfer () {
  return {
    type: actionTypes.BALANCE_TRANSFER_SUCCESS
  };
}

export function requestClubTransfers( dateFrom, dateTo) {
  return {
    type: actionTypes.CLUB_TRANSFERS_REQUEST,
    dateFrom,
    dateTo
  };
}

export function successClubTransfers (transfers) {
  return {
    type: actionTypes.CLUB_TRANSFERS_SUCCESS,
    transfers
  };
}

export function requestGameTransfers ( dateFrom, dateTo ) {
  return {
    type: actionTypes.GAME_TRANSFERS_REQUEST,
    dateFrom,
    dateTo
  };
}

export function successGameTransfers (transfers) {
  return {
    type: actionTypes.GAME_TRANSFERS_SUCCESS,
    transfers
  };
}

export const failureGameTransfers = (e) => ({
  type: actionTypes.GAME_TRANSFERS_FAILURE,
  exception: e,
});